export default __webpack_public_path__ + "static/media/icon-apple.af93bbb9.png";